<card
  [title]="quiz.name"
  [detailUrl]="['quiz/' + quiz.id]"
  [editUrl]="['quiz/' + quiz.id + '/edit']"
  [user]="user"
  [isGrid]="isGrid"
>
</card>
